import React from 'react'
import DashboardLayout from './DashboardLayout';

const Dashboard: React.FC = () => <DashboardLayout />

export default Dashboard;